import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';
import { Keyboard } from '@capacitor/keyboard';
import { App } from '@capacitor/app';

export const isNative = Capacitor.isNativePlatform();
export const isIOS = Capacitor.getPlatform() === 'ios';

// Called once at app startup (no-op on web)
export async function initNativePlugins(): Promise<void> {
  if (!isNative) return;

  // Mark body so CSS native-only rules can target it
  document.body.classList.add('native-app');
  if (isIOS) document.body.classList.add('native-ios');

  // Indigo status bar matching the app header
  await StatusBar.setStyle({ style: Style.Dark }).catch(() => {});
  await StatusBar.setBackgroundColor({ color: '#4f46e5' }).catch(() => {});

  // Keyboard: scroll body up when keyboard opens, don't shrink the viewport
  Keyboard.setAccessoryBarVisible({ isVisible: false }).catch(() => {});

  // Hardware back button (Android-compat — iOS uses swipe gesture natively)
  App.addListener('backButton', ({ canGoBack }) => {
    if (canGoBack) history.back();
    else App.exitApp();
  });
}

// Call this once the app is ready to show (auth check complete)
export async function hideSplash(): Promise<void> {
  if (!isNative) return;
  await SplashScreen.hide({ fadeOutDuration: 300 }).catch(() => {});
}

// Light impact haptic — call on significant UI actions
export async function hapticLight(): Promise<void> {
  if (!isNative) return;
  const { Haptics, ImpactStyle } = await import('@capacitor/haptics');
  await Haptics.impact({ style: ImpactStyle.Light }).catch(() => {});
}

// Medium impact haptic — call on confirmations / destructive actions
export async function hapticMedium(): Promise<void> {
  if (!isNative) return;
  const { Haptics, ImpactStyle } = await import('@capacitor/haptics');
  await Haptics.impact({ style: ImpactStyle.Medium }).catch(() => {});
}
